import React from 'react';

const Disclaimer = props => (
  <div className="mt-3 text-center">
    {props.disclaimer}
  </div>
);

export default Disclaimer;
